import React, { useState } from "react";
import { Link } from "react-router-dom";
import { assets, onAssetError } from "./assets";
import { CONTACT } from "./data";
import { useLanding } from "./LandingContext";

export default function LandingFooter() {
  const { goTo } = useLanding();
  const [email, setEmail] = useState("");

  return (
    <footer style={{ background: "#14090b", color: "#fff" }} data-screen-label="Footer">
      <div
        className="foot-grid"
        style={{
          maxWidth: 1180,
          margin: "0 auto",
          padding: "60px 20px 30px",
          display: "grid",
          gridTemplateColumns: "1.5fr 1fr 1fr 1.3fr",
          gap: 32,
        }}
      >
        <div>
          <div style={{ marginBottom: 14 }}>
            <img src={assets.logoFull} alt="Chainz Solutions" onError={onAssetError} style={{ height: 34, width: "auto" }} />
          </div>
          <div style={{ fontSize: 13.5, lineHeight: 1.7, color: "rgba(255,255,255,0.6)", maxWidth: 280 }}>
            The new generation's inventory management, warehousing and fulfillment system.
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 11 }}>
          <div style={{ fontSize: 12, letterSpacing: "0.2em", color: "rgba(255,255,255,0.5)", marginBottom: 4 }}>PRODUCT</div>
          <a href="#services" onClick={goTo("services", "fulfillment", "home")} style={{ fontSize: 13.5 }}>
            Services
          </a>
          <a href="#products" onClick={goTo("products", "products", "home")} style={{ fontSize: 13.5 }}>
            Solutions
          </a>
          <a href="#how" onClick={goTo("how", "fulfillment", "home")} style={{ fontSize: 13.5 }}>
            How it works
          </a>
          <a href="#integrations" onClick={goTo("integrations", null, "home")} style={{ fontSize: 13.5 }}>
            Integrations
          </a>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 11 }}>
          <div style={{ fontSize: 12, letterSpacing: "0.2em", color: "rgba(255,255,255,0.5)", marginBottom: 4 }}>CONTACT</div>
          <a href={`mailto:${CONTACT.email}`} style={{ fontSize: 13.5 }}>
            {CONTACT.email}
          </a>
          <a href={`tel:${CONTACT.phoneTel}`} style={{ fontSize: 13.5 }}>
            {CONTACT.phone}
          </a>
          <div style={{ fontSize: 13.5, color: "rgba(255,255,255,0.82)" }}>{CONTACT.address}</div>
        </div>
        <div>
          <div style={{ fontSize: 12, letterSpacing: "0.2em", color: "rgba(255,255,255,0.5)", marginBottom: 12 }}>STAY UPDATED</div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setEmail("");
            }}
            style={{
              display: "flex",
              gap: 8,
              background: "rgba(255,255,255,0.08)",
              border: "1px solid rgba(255,255,255,0.16)",
              borderRadius: 999,
              padding: "5px 6px 5px 18px",
              alignItems: "center",
            }}
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              aria-label="Email for newsletter"
              style={{
                flex: 1,
                border: "none",
                background: "transparent",
                color: "#fff",
                fontSize: 13,
                fontFamily: "inherit",
                outline: "none",
                minWidth: 0,
              }}
            />
            <button type="submit" className="btn red" style={{ padding: "9px 18px" }}>
              Subscribe
            </button>
          </form>
        </div>
      </div>
      <div
        style={{
          maxWidth: 1180,
          margin: "0 auto",
          padding: "0 20px 30px",
          fontSize: 12,
          color: "rgba(255,255,255,0.4)",
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          justifyContent: "space-between",
        }}
      >
        <span>© 2026 Chainz Solutions. All rights reserved.</span>
        <Link to="/terms" style={{ color: "rgba(255,255,255,0.4) !important", fontSize: 12 }}>
          Terms & Conditions
        </Link>
      </div>
    </footer>
  );
}
